import React from "react";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Page from "../../components/Page";
import "./styles.css";
import InputField from "../../components/inputField";
import routeNames from "../../routes/routeNames";
import { useForm } from "@mantine/form";
import { backendUrl } from "../../constants";
import { useNavigate } from "react-router-dom";
import { cleanNotifications, showNotification } from "@mantine/notifications";
import GoogleSignIn from "../../components/googleSignInComponent";
import { useEffect } from "react";
import { useState } from "react";

const Index = ({ t }) => {
  const navigate = useNavigate();

  const [googleData, setGoogleData] = useState(null);
  useEffect(() => {
    if (googleData) {
      console.log("Google Data: ", googleData);
      form.setFieldValue("firstName", googleData.given_name);
      form.setFieldValue("lastName", googleData.family_name);
      form.setFieldValue("email", googleData.email);
    }
  });

  const form = useForm({
    validateInputOnChange: true,
    initialValues: { email: "", pass: "" },

    // functions will be used to validate values at corresponding key
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      pass: (value) => (value?.length < 1 ? "Enter password" : null),
    },
  });

  const handleSignIn = (values) => {
    let obj = { email: values.email, password: values.pass };
    if (true) {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(obj),
      };
      fetch(`${backendUrl}user/login`, options)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            response?.data &&
              localStorage.setItem("userData", JSON.stringify(response.data));
            if (
              response.data.role === "Company" ||
              response.data.role === "employee"
            ) {
              navigate(routeNames.employer.dashboard);
              window.location.reload();
            } else if (response.data.role === "JobSeeker") {
              console.log("JOBSEEKER")
              navigate(routeNames.jobSeeker.dashboard);
              window.location.reload();
            } else if (response.data.role === "Admin") {
              showNotification({
                title: "Welcome Admin",
                message: "You are logged in as Admin",
                color: "green",
              });
              navigate(routeNames.admin.dashboard);
            }
          } else {
            cleanNotifications();
            showNotification({
              title: "Wrong Credentials",
              message: response.message,
              color: "red",
            });
          }
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <Page className="landing-page">
      <div className="mainLogin">
        <form
          onSubmit={form.onSubmit((values) => handleSignIn(values))}
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="loginmain row">
            <div className="loginForm">
              <div className="d-flex gap-4 flex-column w-100">
                <h3 className="text-dark text-center">Log in</h3>
                <InputField
                  placeholder={"Enter Email"}
                  className="m"
                  type="email"
                  width="100%"
                  form={form}
                  validateName="email"
                />
                <InputField
                  placeholder={"Enter Password"}
                  className="m"
                  type="password"
                  width="100%"
                  form={form}
                  validateName="pass"
                />
                {/* <Alert color="red" title="Error" message={"Wrong Credentials."}/> */}
              </div>
            </div>
            <div className="d-flex flex-column">
              <a href="/" className="text-black">
                Forgot Your Password?
              </a>
              <div className="form-check">
                <input
                  className="form-check-input bg-danger border-white"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                />
                <label
                  className="form-check-label text-black font-size-8"
                  htmlFor="flexCheckChecked"
                >
                  Keep me logged in on this computer.
                </label>
              </div>
            </div>
            <div className="align-items-center d-flex flex-column gap-2">
              <Button
                title={"Log in"}
                primary={true}
                disable={false}
                fontWeight="700"
                type="submit"
                width="100%"
              />
              <GoogleSignIn type={"signin"} />
              {/* <h4 className="text-dark">OR</h4>
              <Button
                title={"Sign in with Facebook"}
                icon={"fb"}
                fontWeight="700"
                type="submit"
                width="100%"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "rgb(12, 80, 170)",
                  color: "white",
                }}
              /> */}
              <h6 className="text-black">
                Not registered? Sign up as a{" "}
                <a
                  href={routeNames.general.employer}
                  className="text-dark text-decoration-none"
                >
                  employer
                </a>{" "}
                or{" "}
                <a
                  href={routeNames.general.jobSeeker}
                  className="text-dark text-decoration-none"
                >
                  jobseeker
                </a>
              </h6>
            </div>
          </div>
        </form>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
